/**
 * Chat Store - EventDrivenStore implementation
 * Manages chat widget state for customer support
 */

import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import { CHAT_STATUS } from './constants';

class ChatStore extends EventDrivenStore {
  constructor() {
    super('chat', {
      status: CHAT_STATUS.NOT_INITIALIZED,
      isOpen: false,
      currentConversation: null,
      unreadCount: 0,
      adminInfo: {
        id: constants.CHAT_CONFIG.adminUserId,
        name: 'Support Rapidoo',
        email: 'support@rapidoo.com'
      }
    });
  }

  setupEvents() {
    // Chat initialization events
    bus.on(constants.EVENTS.CHAT.INIT, () => {
      this.state.status = CHAT_STATUS.INITIALIZING;
    });

    bus.on(constants.EVENTS.CHAT.INIT_SUCCESS, () => {
      this.state.status = CHAT_STATUS.INITIALIZED;
    });

    bus.on(constants.EVENTS.CHAT.INIT_ERROR, (error) => {
      this.state.status = CHAT_STATUS.ERROR;
      console.error('Chat initialization error:', error);
    });

    // Chat conversation events
    bus.on(constants.EVENTS.CHAT.OPEN_CONVERSATION, (conversation) => {
      this.state.currentConversation = conversation;
      this.state.isOpen = true;
    });

    bus.on(constants.EVENTS.CHAT.CLOSE, () => {
      this.state.isOpen = false;
    });

    // Listen for user login to init chat
    bus.on(constants.EVENTS.USER.LOGIN_SUCCESS, () => {
      // Chat will be initialized by setupChatWidget
    });
  }
}

export default ChatStore;
